const state = {
  isQuizCompleted: false,
  matchData: null,
  dealId: '',
  lendersInDeal: 0,
  newPhone: '',
  newExtension: '',
  questions: null,
}

const mutations = {
  SET_LENDERS_IN_DEAL (state, count) {
    state.lendersInDeal = count
  },

  SET_QUIZ_COMPLETED (state) {
    state.isQuizCompleted = true
  },

  SET_QUIZ_UNCOMPLETED (state) {
    state.isQuizCompleted = false
  },

  SET_MATCH_DATA (state, matchData) {
    state.matchData = matchData
  },

  UPDATE_MATCH_DATA (state, data) {
    state.matchData = Object.assign({},
      state.matchData,
      data,
    )
  },
  CLEAR_MATCH_DATA (state) {
    state.matchData = null
  },

  SET_DEAL_ID (state, id) {
    state.dealId = id
  },

  CLEAR_DEAL_ID (state) {
    state.dealId = ''
  },

  SET_QUESTIONS (state, questions) {
    state.questions = questions
  },

  SET_NEW_PHONE (state, { extension, phone }) {
    state.newExtension = extension
    state.newPhone = phone
  },

  CLEAR_NEW_PHONE (state) {
    state.newExtension = ''
    state.newPhone = ''
  },
}

const actions = {
  setLendersInDeal ({ commit }, count) {
    commit('SET_LENDERS_IN_DEAL', count)
  },
  setQuizCompleted (context) {
    context.commit('SET_QUIZ_COMPLETED')
  },
  setMatchData (context, payload) {
    context.commit('SET_MATCH_DATA', payload)
  },
  updateMatchData ({ commit }, data) {
    commit('UPDATE_MATCH_DATA', data)
  },
  clearMatchData (context) {
    context.commit('CLEAR_MATCH_DATA')
  },
  setDealId (context, dealId) {
    context.commit('SET_DEAL_ID', dealId)
  },
  clearDealId (context) {
    context.commit('CLEAR_DEAL_ID')
  },
  setQuestions ({ commit }, data) {
    commit('SET_QUESTIONS', data)
  },
}

const getters = {
  selectedCommercial: ({ matchData }) => {
    return matchData && (matchData.dealType || []).includes('Commercial Building & Renovation')
  },
  selectedConv: (state) => {
    const { matchData } = state
    return matchData && matchData.loanType === 'Conv'
  },
  selectedSBA: (state) => {
    const { matchData } = state
    return matchData && matchData.loanType === 'SBA'
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
}
